const PRODUCT_USER_LIST_CACHE_ID = 'ProductUserList';
const PRODUCT_USER_LIST_EVENT = {
  UPDATE: {
    COUNT: 'UpdateProductUsersCount',
    LIST: 'UpdateProductUsersList',
  },
};

export {PRODUCT_USER_LIST_CACHE_ID, PRODUCT_USER_LIST_EVENT};
